import './App.css';
import Home from "../src/pages/Home";


function App() {
  return (
    <div className="app">
      <Home/>
    </div>
  );
}

export default App;
